const GlobalVariables = {
  install(Vue) {
    Vue.prototype.$mediaURI = process.env.VUE_APP_BASE_URL_MEDIA;
    this.resize(Vue);
    window.onresize = () => {
      this.resize(Vue);
    };
  },
  resize(Vue) {
    let hMainScreen = window.innerHeight - 255;
    let hControl = hMainScreen < 340 ? 340 : hMainScreen;

    if (hMainScreen < 650) hMainScreen = 650;
    Vue.prototype.$hMainScreen = hMainScreen;
    let hMainContent = (hMainScreen * 65) / 100;
    Vue.prototype.$hMainContent = hMainContent;
    Vue.prototype.$hControl = hControl;
    let hSecondaryContent = hMainScreen - hMainContent - 30;
    Vue.prototype.$hSecondaryContent =
      hSecondaryContent < 270 ? 270 : hSecondaryContent;
  }
};
export default GlobalVariables;
